/**
 * UrnWorth photo-upload addon handler.
 *
 * Handles any `.uw-photo-input` file field rendered by
 * snippets/urnworth-engraving-field-single.liquid. Uploads directly to
 * Cloudinary (unsigned upload), then writes the resulting URL into a HIDDEN
 * LINE-ITEM PROPERTY (properties[...]) that travels with the specific urn
 * the customer uploaded it for.
 *
 * This is intentionally NOT written to cart attributes. Cart attributes are
 * shared across the entire cart, so a second photo upload on a second
 * product would silently overwrite the first. Line-item properties are
 * scoped per cart line, so this can't happen no matter how many customized
 * urns are in the cart at once.
 *
 * EDIT THESE if the Cloudinary account changes:
 */
var UW_CLOUDINARY_CLOUD_NAME = 'dtmm0b0yr';
var UW_CLOUDINARY_UPLOAD_PRESET = 'urn_photos';

(function () {
  function generateRef() {
    return 'PHOTO-' + Math.random().toString(36).toUpperCase().slice(2, 8);
  }

  function handleFileChange(input) {
    var file = input.files[0];
    if (!file) return;

    var statusEl = document.getElementById(input.dataset.photoStatus);
    var previewEl = document.getElementById(input.dataset.photoPreview);
    var previewImg = previewEl ? previewEl.querySelector('img') : null;
    var urlField = document.getElementById(input.dataset.photoUrlField);
    var refField = document.getElementById(input.dataset.photoRefField);
    var revealEl = document.getElementById(input.dataset.photoReveal);

    if (!file.type.startsWith('image/')) {
      if (statusEl) statusEl.textContent = '❌ Please upload an image file.';
      return;
    }
    if (file.size > 10 * 1024 * 1024) {
      if (statusEl) statusEl.textContent = '❌ Image must be under 10MB.';
      return;
    }

    if (statusEl) statusEl.textContent = '⏳ Uploading photo...';

    var ref = generateRef();
    var handle = input.dataset.productHandle || 'urn';
    var timestamp = new Date().toISOString().slice(0, 19).replace(/[T:]/g, '-');
    var publicId = 'urn-orders/' + ref + '_' + handle + '_' + timestamp;

    var formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', UW_CLOUDINARY_UPLOAD_PRESET);
    formData.append('public_id', publicId);

    fetch('https://api.cloudinary.com/v1_1/' + UW_CLOUDINARY_CLOUD_NAME + '/image/upload', {
      method: 'POST',
      body: formData,
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Upload failed');
        return res.json();
      })
      .then(function (data) {
        // Scoped to THIS line item's properties, not a cart-wide attribute.
        if (urlField) urlField.value = data.secure_url;
        if (refField) refField.value = ref;

        if (previewImg) previewImg.src = data.secure_url;
        if (previewEl) previewEl.style.display = 'block';
        if (statusEl) statusEl.innerHTML = '✅ Photo uploaded! Ref: <strong>' + ref + '</strong>';
        if (revealEl) revealEl.style.display = 'block';
      })
      .catch(function () {
        if (statusEl) statusEl.textContent = '❌ Upload failed. Please try again.';
      });
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest('.uw-photo-input');
    if (input) handleFileChange(input);
  });
})();
